import { useState } from 'react';
import { useContent } from '../ContentContext';
import { useAuth } from '../context/AuthContext';
import { AuthApi } from '../api';
import { PageHero } from '../components/Common';

// Account & Data Deletion — required for the Play Store listing. Logged-in users
// can delete their account here; everyone can request deletion by email.
export default function DeleteAccount() {
  const { company = {} } = useContent();
  const { isLoggedIn, logout } = useAuth();
  const email = company.email || 'support@goldentajrice.com';
  const name = company.name || 'Golden Taj Rice';

  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState('');

  const del = async () => {
    if (!window.confirm('This permanently deletes your account and personal data. This cannot be undone. Continue?')) return;
    setBusy(true); setErr('');
    try {
      await AuthApi.deleteAccount();
      setDone(true);
      setTimeout(() => logout(), 2500);
    } catch (e) { setErr(e.message); } finally { setBusy(false); }
  };

  return (
    <>
      <PageHero title="Account & Data Deletion" />

      <section>
        <div className="container legal-page">
          <p>
            You can delete your {name} account and personal data at any time. This removes your profile,
            saved addresses, wishlist, reviews and support tickets from our systems.
          </p>

          <h3>Delete your account</h3>
          {isLoggedIn ? (
            done ? (
              <p className="form-msg ok"><i className="fas fa-circle-check" /> Your account and personal data have been deleted.</p>
            ) : (
              <>
                <p className="muted">You are signed in. Deleting is permanent and cannot be undone.</p>
                {err ? <p className="form-msg err">{err}</p> : null}
                <button className="btn-gold" style={{ background: '#c0392b' }} disabled={busy} onClick={del}>
                  {busy ? 'Deleting…' : 'Permanently delete my account'}
                </button>
              </>
            )
          ) : (
            <p>
              <a href="/login">Sign in</a> to delete your account instantly from this page, or request deletion
              by email as described below.
            </p>
          )}

          <h3>Request deletion by email</h3>
          <p>
            Send an email to <a href={`mailto:${email}?subject=Account%20deletion%20request`}>{email}</a> from
            your registered email address, or including your registered mobile number, with the subject
            “Account deletion request”. We will verify and delete your account and personal data within 7 days.
          </p>

          <h3>What is deleted</h3>
          <ul>
            <li>Your profile (name, phone number, email).</li>
            <li>Saved delivery addresses.</li>
            <li>Wishlist, ratings and reviews.</li>
            <li>Support tickets and chat details.</li>
          </ul>

          <h3>What we keep</h3>
          <p>
            Completed order and invoice records may be retained where required for tax, accounting and legal
            obligations, but they are no longer linked to your personal profile.
          </p>

          <p className="muted" style={{ marginTop: 24 }}>
            Questions? Contact us at <a href={`mailto:${email}`}>{email}</a>. See also our{' '}
            <a href="/privacy">Privacy Policy</a>.
          </p>
        </div>
      </section>
    </>
  );
}
